import { useEffect, useState } from "react"
import { Home, GraduationCap, User, Shield, Gamepad2 } from "lucide-react"
import { useStudentNavigation } from "@/contexts/StudentNavigationContext"
import type { StudentPage } from "@/contexts/StudentNavigationContext"

const navItems: { page: StudentPage; icon: typeof Home; label: string }[] = [
  { page: 'home',      icon: Home,          label: 'Home'    },
  { page: 'classroom', icon: GraduationCap, label: 'Classes' },
  { page: 'games',     icon: Gamepad2,      label: 'Games'   },
  { page: 'safety',    icon: Shield,        label: 'Safety'  },
  { page: 'profile',   icon: User,          label: 'Profile' },
]

function FooterBar() {
  const { currentPage, setCurrentPage } = useStudentNavigation()
  const [dm, setDm] = useState(() => localStorage.getItem('studentDarkMode') === 'true')

  useEffect(() => {
    const handler = (e: Event) => setDm((e as CustomEvent<{ darkMode: boolean }>).detail.darkMode)
    window.addEventListener('studentDarkModeChanged', handler)
    return () => window.removeEventListener('studentDarkModeChanged', handler)
  }, [])

  return (
    <nav className={`flex-shrink-0 backdrop-blur-xl border-t safe-area-bottom z-40 ${
      dm
        ? 'bg-slate-900/95 border-slate-700/60 shadow-[0_-2px_20px_rgba(0,0,0,0.4)]'
        : 'bg-white/85 border-white/50 shadow-[0_-2px_20px_rgba(99,102,241,0.12)]'
    }`}>
      <div className="flex items-stretch h-16 max-w-2xl mx-auto px-1">
        {navItems.map(({ page, icon: Icon, label }) => {
          const active = currentPage === page
          return (
            <button
              key={page}
              onClick={() => setCurrentPage(page)}
              className="flex-1 flex flex-col items-center justify-center gap-0.5 relative"
              style={{ background: 'none', border: 'none' }}
            >
              {/* Top active bar */}
              <div
                className={`absolute top-0 left-1/2 -translate-x-1/2 h-0.5 rounded-full transition-all duration-300 ${
                  active ? 'w-6 bg-indigo-500' : 'w-0 bg-transparent'
                }`}
              />

              {/* Icon pill */}
              <div
                className={`flex items-center justify-center w-10 h-7 rounded-xl transition-all duration-200 ${
                  active
                    ? dm ? 'bg-indigo-500/20' : 'bg-indigo-50'
                    : ''
                }`}
              >
                <Icon
                  className={`transition-all duration-200 w-5 h-5 ${
                    active
                      ? 'text-indigo-500'
                      : dm ? 'text-slate-500' : 'text-gray-400'
                  }`}
                />
              </div>

              {/* Label */}
              <span
                className={`text-[10px] font-medium leading-none transition-colors duration-200 ${
                  active
                    ? 'text-indigo-500'
                    : dm ? 'text-slate-500' : 'text-gray-400'
                }`}
              >
                {label}
              </span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}

export default FooterBar
